import { customAxios, IDUSUARIO, FDV_URL, USERNAME } from '../constants';

export default function(idFichaVtaVeh,idProforma,codCia,codProv,numPedidoVeh,indAplicaHito) {
  const config = {
    params: {
      numFichaVtaVeh:idFichaVtaVeh,
      numeroproforma:idProforma,
      numeropedido:numPedidoVeh,
      codCia,
      codProv,
      indAplicaHito
    },
    headers: {
      idUsuario: IDUSUARIO,
      codUsuario: USERNAME
    },
  };
  // http://172.20.200.45:8080/sid-ficha-venta/ficha-venta/fichas-venta/000000034253/pedidosautorizaciones
  return customAxios.get(`${FDV_URL}/ficha-venta/fichas-venta/hito-pedido`, config);
}
// export default function(id,idProforma,codCia,codProv,numPedidoVeh) {
//   const config = {
//   //   params: {
//   //     codCia,
//   //     codProv,
//   //   },
//   //   headers: {
//   //     idUsuario: IDUSUARIO,
//   //   },
//   };
//   // http://localhost:3004/pedidosAutorizaciones
//   return customAxios.get(`${LOCAL_URL}/pedidosAutorizaciones`, config);
// }



// WEBPACK FOOTER //
// ./src/utils/getPedidosPedidosAutorizaciones.js